$(function() {

    if (window.innerWidth < 991.98) {
        $('body').on('click','.js-footermenu-toggle', e => {
            e.preventDefault();
            const footerMenu  = $(e.currentTarget).parent().find('.js-footermenu');
            const toggleIcon = $(e.currentTarget).parent().find('i');
            if(footerMenu.hasClass('d-none')) {
                footerMenu.removeClass('d-none');
                toggleIcon.removeClass('fa-chevron-down');
                toggleIcon.addClass('fa-chevron-up');
            } else {
                footerMenu.addClass('d-none');
                toggleIcon.removeClass('fa-chevron-up');
                toggleIcon.addClass('fa-chevron-down');
            }
        });
    }
});

(function(){
    'use strict';

    // function to prevent default events
    function pde(evt) {
        if(evt) {
            evt.preventDefault();
        }
    }
    // activate imgliquid
    $('.imgliquid').each(function(){
        var container = $(this);
        var image = $('> img:first',container);
        container.css("background-image", 'url("' + encodeURI(image.attr('src')).replace(/%2520/g, '%20') + '")');
    });

    // timer variable
    var popovertimer = null;

    // IE11 caching fix
    $.ajaxSetup({cache: false});

    // enhanced ecommerce click
    $('.js-ecomm-product').on('click.ecomm', function() {
        if(typeof dataLayer === 'object') {
            dataLayer.push({
                event: 'productClick',
                ecommerce: {
                    click: {
                        actionField: {
                            list: $(this).data('field')
                        },
                        products: [{
                            id: $(this).data('id'),
                            name: $(this).data('name'),
                            price: $(this).data('price'),
                            brand: $(this).data('brand'),
                            category: $(this).data('category'),
                            position: $(this).data('position'),
                        }]
                    }
                }
            });
        }
    });

    // scroll automatically to product questions
    if(window.location.hash === '#product-questions') {
        $('html,body').animate({
            scrollTop: ($('#product-questions').offset().top - 110)
        }, 1);
    }

    // mobile menu
    $('.navbar-collapse').on('show.bs.collapse', function() {
        $('html').addClass('navbar-open');
        $('.navbar-cart, .navbar-checkout').removeClass('active');
    }).on('hide.bs.collapse', function() {
        $('html').removeClass('navbar-open');
    });

    // microcart
    var update_cart;
    var priceFormatPrefix = ($('html').prop('lang') === 'de') ? '€' :'';

    $('.js-microcart').each(function(){
        var $cart = $(this),
            $toggle = $('.js-microcart-toggle'),
            $empty = $('.js-microcart-empty'),
            $inner = $('.js-microcart-inner'),
            $close = $('.js-microcart-close'),
            $products = $('.js-microcart-products'),
            $nav = $('.navbar-collapse');

        $inner.hide();

        $toggle.on('click', function(){
            $toggle.toggleClass('active');
            $cart.toggleClass('active');

            if($cart.hasClass('active')){
                setTimeout(update_cart, 400);
            }

            $nav.each(function(){
                $(this).collapse('hide');
            });
        });

        $close.on('click', function(){
            $toggle.removeClass('active');
            $cart.removeClass('active');
        });

        update_cart = function(){
            $close.find('i.icon-close').removeClass('icon-close').addClass('fa fa-refresh fa-spin');

            // Current product properties, if any
            var $productForm = $('.product-form');
            if($productForm) {
                var currentProductId = parseInt($productForm.find('input[name="productkey"]').val());
                var currentProductMaxCount = $productForm.find('.js-product-count').data('max');
            }

            $.getJSON('/bjax/webshop/Getobjectasjson/cart/', function(data) {

                if(data.itemcount > 0){
                    $empty.hide();
                    $cart.removeClass('empty');
                    $toggle.removeClass('empty');

                    $('.navbar-mobile-menu').removeClass('highlighted');

                    var itemcount = data.itemcount;

                    if(itemcount > 4){
                        itemcount = 4;
                    }

                    $('.js-microcart-items-shown').text(itemcount);
                    $('.js-microcart-items-total').text(data.itemcount);
                    $('.js-microcart-subtotal').html(zilvercms.currencyHelper(data.subtotal_excl_btw));
                    if (data.shipping === 0) {
                        $('.js-microcart-shipping').addClass("text-success").text(function() {
                            return $(this).data('translation');
                        });
                    } else {
                        $('.js-microcart-shipping').html(zilvercms.currencyHelper(data.shipping));
                    }
                    $('.js-microcart-total').html(zilvercms.currencyHelper(data.total_excl_btw));

                    $products.empty();

                    for(var i = 0; i < data.items.length; i++) {
                        var itemId = data.items[i].product_id;

                        if(typeof currentProductId !== 'undefined' && currentProductId === itemId) {
                            var itemCount = parseInt(data.items[i].count);
                            if(itemCount >= currentProductMaxCount) {
                                $productForm.find('.js-product-count').val(0).attr({
                                    'data-min': 0,
                                    'data-max': 0
                                });
                                $productForm.find('button[type="submit"]').attr('disabled', 'disabled');
                            } else {
                                $productForm.find('.js-product-count').attr('data-max', (currentProductMaxCount - itemCount));
                            }
                        }

                        if(i < 4) {
                            $products.append('<li><a href="'+data.items[i].product_url+'"><span class="image"><img src="'+zilvercms.imageHelper(data.items[i].image_url, '100x100,fit')+'" alt="'+data.items[i].name+'"></span><span class="price">'+data.items[i].count+'x &nbsp;|&nbsp; <span class="pricetotal js-pricetotal">'+data.items[i].current_price_excl_btw+'</span></span></a></li>');
                        }
                    }

                    $products.find('.js-pricetotal').each(function() {
                        $(this).html(zilvercms.currencyHelper($(this).html()));
                    });

                    $inner.show();
                }else{
                    $cart.addClass('empty');
                    $inner.hide();
                    $empty.show();

                    $('.navbar-mobile-menu').addClass('highlighted');
                }

                $('.js-microcart-toggle-count').text(data.itemcount);
                $('.js-microcart-toggle-products').html(zilvercms.currencyHelper(data.total));


                $close.find('i.fa-refresh').removeClass('fa fa-refresh fa-spin').addClass('icon-close');
            });
        };

        update_cart();
    });



    //compare message if only one is selected
    $('.webshop-productlist').each(function() {
        $(this).find('.btn-compare').click(function () {
            var compareids = $('#compareids').val().split(',');
            if (!compareids[1]) {
                alert('U heeft nog niet 2 producten geselecteerd om te kunnen vergelijken');
                return false;
            } else if (compareids[4]) {
                alert('U kan niet meer dan 4 producten met elkaar vergelijken');
                return false;
            }
        });
    });

    $(document).on('change', 'input:checkbox[name=productcompare]', function () {
        var values = $('input:checkbox[name=productcompare]:checked').map(function () {
            return this.value;
        }).get();
        $('#compareids').val(values);
    });

    $('#customMessageModal').each(function() {
        var saveBtn = $('.btn-addmessage');
        var message = $('.js-customMessage');
        saveBtn.on('click',function () {
            message.fadeIn();
        });
    });

    // product page scripts
    if($('.webshop-product-page').size() > 0) {
        var product_form = $('.webshop-product-page .product-form');
        var count_container = product_form.find('.product-count');
        var btn_minus = count_container.find('.btn-minus');
        var btn_plus = count_container.find('.btn-plus');
        var count = count_container.find('.form-control');
        var button = product_form.find('.product-submit');
        var maxamount = product_form.find('input[name=maxaantal]');
        var variant = product_form.find('.product-variant .form-control');
        var product_form_fixed = $('.webshop-product-page .product-form-fixed');
        var fixed_count_container = product_form_fixed.find('.product-count');
        var fixed_btn_minus = fixed_count_container.find('.btn-minus');
        var fixed_btn_plus = fixed_count_container.find('.btn-plus');
        var fixed_count = fixed_count_container.find('.form-control');
        var fixed_button = product_form_fixed.find('.product-submit');
        var fixed_variant = product_form_fixed.find('.product-variant .form-control');
        var $reminderForm = $('.js-reminder-form');

        // Reminder form
        $reminderForm.validate({
            errorElement: 'span',
            errorClass: 'error',
            errorPlacement: function($error) {
                $reminderForm.find('.js-reminder-msg').html($error);
            },
            submitHandler: function(form) {
                var $form = $(form);
                $form.find('.btn').html('<i class="fa fa-cog fa-spin"></i>');

                $.ajax({
                    type: $form.attr('method'),
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    success: function(response) {
                        if(response == 'success') {
                            $form.addClass('disabled');
                            $form.find('.btn').html('<i class="fa fa-check"></i>');
                            $form.find('.js-reminder-msg').text($form.attr('data-succes-msg'));
                        }
                    }
                });
            }
        });

        // product fixed form scroll watcher
        var product_form_fixed_scroll_event = function(){
            if($(window).scrollTop() >= 850 && !product_form_fixed.is(':visible')) {
                product_form_fixed.slideDown(150);
            }
            else if($(window).scrollTop() < 850 && product_form_fixed.is(':visible')) {
                product_form_fixed.slideUp(150);
            }
        };
        $(window).resize(function(){
            product_form_fixed_scroll_event();
        });
        $(window).scroll(function(){
            product_form_fixed_scroll_event();
        });
        $('body').bind('touchmove', function(){
            product_form_fixed_scroll_event();
        });

        // product page change price
        variant.bind('change', function(event){
            variant.parent().find('.alert').remove();
            fixed_variant.parent().find('.alert').remove();
            fixed_variant.val($(this).val());
            var price = parseInt(product_form.find('input[name=productprice]').val());
            var exbtwprice = parseInt(product_form.find('input[name=productexprice]').val());
            if(variant.val() !== '') {
                var option_price = variant.find('option:selected').attr("labelprice");
                var option_price_exbtw = variant.find('option:selected').attr("labelexbtw");
                if(option_price !== '') {
                    price = parseInt(option_price);
                    exbtwprice = parseInt(option_price_exbtw);
                }
            }
            product_form.find('.product-price span').addClass('highlight').text(price).priceFormat({
                prefix: priceFormatPrefix,
                centsSeparator: ',',
                thousandsSeparator: ''
            });
            product_form.find('.product-price em').text(exbtwprice).priceFormat({
                prefix: priceFormatPrefix,
                suffix: ' excl.btw',
                centsSeparator: ',',
                thousandsSeparator: ''
            });
            product_form_fixed.find('.product-price').addClass('highlight').text(price).priceFormat({
                prefix: priceFormatPrefix,
                centsSeparator: ',',
                thousandsSeparator: ''
            });
            setTimeout(function(){
                product_form.find('.product-price span').removeClass('highlight');
                product_form_fixed.find('.product-price').removeClass('highlight');
            }, 100);
        });
        fixed_variant.bind('change', function(event){
            variant.val($(this).val()).change();
        });

        // product page input count only number
        var $plusBtn = $('.js-plus-btn');
        var $minusBtn = $('.js-minus-btn');
        var $productAmount = $('.js-product-count');
        var $productMainAmount = count;
        var _popoverTimer;

        $productAmount.on('focusout', function() {
            var $currentAmount = $(this);
            var currentValue = parseInt($currentAmount.val());
            var minProductAmount = parseInt($productMainAmount.attr('data-min'));
            var maxProductAmount = parseInt($productMainAmount.attr('data-max'));
            var stepProductAmount = parseInt($productMainAmount.attr('step'));


            if(currentValue === '' || isNaN(currentValue) || currentValue < minProductAmount) {
                var newValue = minProductAmount;


            } else if (!isNaN(maxProductAmount) && currentValue > maxProductAmount) {
                var newValue = maxProductAmount;
                $currentAmount.next('.js-popover').fadeIn();

                clearTimeout(_popoverTimer);
                _popoverTimer = setTimeout(function() {
                    $currentAmount.next('.js-popover').fadeOut();
                }, 5000);
            } else {
                var value = currentValue;
                var rest = value % stepProductAmount;
                if(rest !== 0){
                    value += (stepProductAmount - rest);
                }
                var newValue = value;
            }

            $productAmount.val(newValue);
            $productAmount.parent().find('.alert').remove();
        });

        $minusBtn.on('click.minus', function() {
            var minProductAmount = parseInt($productMainAmount.attr('data-min'));
            var maxProductAmount = parseInt($productMainAmount.attr('data-max'));
            var stepProductAmount = parseInt($productMainAmount.attr('step'));
            var currentValue = parseInt($productMainAmount.val());
            var newValue = (currentValue <= minProductAmount) ? minProductAmount : (currentValue - stepProductAmount);

            $productAmount.next('.js-popover').fadeOut();
            $productAmount.val(newValue);
            $productAmount.parent().find('.alert').remove();
        });

        $plusBtn.on('click.plus', function() {
            var minProductAmount = parseInt($productMainAmount.attr('data-min'));
            var maxProductAmount = parseInt($productMainAmount.attr('data-max'));
            var stepProductAmount = parseInt($productMainAmount.attr('step'));
            var currentValue = parseInt($productMainAmount.val());
            var newValue = (currentValue + stepProductAmount);

            if(!isNaN(maxProductAmount) && newValue > maxProductAmount) {
                var newValue = maxProductAmount;
                var $productCount = $(this).next('.js-product-count');
                $productCount.next('.js-popover').fadeIn();

                clearTimeout(_popoverTimer);
                _popoverTimer = setTimeout(function() {
                    $productCount.next('.js-popover').fadeOut();
                }, 5000);
            }

            $productAmount.val(newValue);
            $productAmount.parent().find('.alert').remove();
        });

        // product page order event
        product_form.submit(function(event){
            if(variant.length && variant.val() === '') {
                variant.parent().find('.alert').remove();
                fixed_variant.parent().find('.alert').remove();
                $('<div class="alert alert-danger">U heeft geen variant geselecteerd</div>').insertAfter(variant);
                $('<div class="alert alert-danger">U heeft geen variant geselecteerd</div>').insertAfter(fixed_variant);
            }
            else if(maxamount.length && parseInt(count.val()) > parseInt(maxamount.val())) {
                count.parent().find('.alert').remove();
                fixed_count.parent().find('.alert').remove();
                $('<div class="alert alert-danger">U kunt maximaal '+ maxamount.val() +' bestellen</div>').insertAfter(count);
                $('<div class="alert alert-danger">U kunt maximaal '+ maxamount.val() +' bestellen</div>').insertAfter(fixed_count);
            }
            else {
                button.button('loading');
                fixed_button.button('loading');
                var _count = parseInt(count.val());
                $.ajax({
                    type: "POST",
                    url: "/cart/",
                    dataType: "json",
                    data: product_form.serialize(),
                    complete: function() {
                        if($(window).width() <= 767) {
                            $("html,body").stop(true, true).animate({scrollTop: 0}, 333);
                        }
                        button.button('reset');
                        fixed_button.button('reset');
                        product_form[0].reset();
                        product_form_fixed[0].reset();
                        if($('.js-microcart').hasClass('active')) {
                            update_cart();
                        } else {
                            setTimeout(update_cart, 400);
                            $('.js-microcart').addClass('active');
                            $('.js-microcart-toggle').addClass('active');
                        }
                        if(typeof window.productDetails === 'object' && typeof window.dataLayer === 'object'){
                            productDetails.quantity = _count;
                            dataLayer.push({
                                event: 'addToCart',
                                ecommerce: {
                                    currencyCode: 'EUR',
                                    add: {
                                        products: [productDetails]
                                    }
                                }
                            });
                        }
                    }
                });
            }
            pde(event);
        });
        fixed_button.bind('click',function(){
            product_form.submit();
        });



        // product page anchorlinks
        $('.js-product-anchor-link').each(function() {
            var $link = $(this);
            var anchor = $link.attr('href');
            var $target = $(anchor);
            if($target.length) {
                $link.on('click.anchor', function(event) {
                    $('html, body').animate({
                        scrollTop: $target.offset().top - 200
                    }, 333);
                    pde(event);
                });
            } else {
                $link.parent().remove();
            }
        });


        // product questions ask question
        $('.product-questions-ask-question').bind("click", function(event){
            $(this).hide();
            $('.product-questions-empty').hide();
            $('.product-questions-form').removeClass('hide').delay(1).queue(function(next){
                $(this).addClass('in');
                next();
            });
            pde(event);
        });

        // product questions ask question
        $('.js-product-renting').bind("click", function(event){
            $(this).hide();
            $('.js-product-renting-empty').hide();
            $('.js-product-renting-form').removeClass('hide').delay(1).queue(function(next){
                $(this).addClass('in');
                next();
            });
            pde(event);
        });

        // product question submit form event
        $('.product-questions-form').submit(function(event){
            var form = $(this);
            if(form.valid()){
                form.find(".product-questions-submit").button('loading');
                $.ajax({
                    type: "POST",
                    url: "/bjax/ProductQuestion/Ask",
                    dataType: "json",
                    data: form.serialize(),
                    success: function(response) {
                        form.find(".product-questions-submit").button('reset');
                        form.find(".form-success-overlay").removeClass('hide').delay(1).queue(function(next){
                            $(this).addClass('in');
                            next();
                        });
                        clearTimeout(popovertimer);
                        popovertimer = setTimeout(function(){
                            form[0].reset();
                            form.removeClass('in').delay(100).queue(function(next){
                                $(this).addClass('hide');
                                form.find(".form-success-overlay").removeClass('in').addClass('hide');
                                $('.product-questions-ask-question, .product-questions-empty').fadeIn(100);
                                next();
                            });
                        },3000);
                    },
                    error: function (response) {
                        form.find(".product-questions-submit").button('reset').popover('destroy').popover({
                            placement: 'top',
                            trigger: 'manual',
                            content: 'Het is niet gelukt om de vraag te versturen',
                            template: '<div class="popover fade top in"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                        }).popover('show');
                        clearTimeout(popovertimer);
                        popovertimer = setTimeout(function(){
                            form.find(".product-questions-submit").popover('destroy');
                        },3000);
                    }
                });
            }
            pde(event);
        });
    }

    // active state to panels
    $('.panel-heading a').bind('click',function(){
        $('.panel').removeClass('active');
        var panel = $(this).parents('.panel');
        if(panel.find('.panel-collapse').hasClass('in')) {
            panel.removeClass('active');
        } else {
            panel.addClass('active');
        }
    });

    // modals to show or not to show
    if($('#modal-newsletter').size() > 0) {
        if(!$.cookie('nieuwsbrief')) {
            $.cookie('nieuwsbrief', '0', { expires: 1, path: '/' }); // 1 dag
        }else{
            if(parseInt($.cookie('nieuwsbrief')) === 2){
                setTimeout(function(){
                    if($(window).width() < 768){
                        $('#modal-newsletter').modal({backdrop: false});
                        $("body").removeClass("modal-open");
                    }else{
                        $('#modal-newsletter').modal('show');
                    }
                }, 3000);
            }
            var cookie = parseInt($.cookie('nieuwsbrief')) + 1;
            $.cookie('nieuwsbrief', cookie, { expires: 1, path: '/' }); // 1 dag
        }
    }

    // leaving cart and checkout modal
    if($('#modal-checkout-leaving').size() > 0) {
        $(document).bind("mouseleave",function(event){
            if(event.pageY - $(window).scrollTop() <= 1 && ($('.checkout-cart-submit').length || $('.checkout-order-submit').length || $('.checkout-redirect-submit').length) && !$.cookie('checkout_leave')) {
                $.cookie('checkout_leave', true, { expires: 1, path: '/' }); // 1 dag
                $('#modal-checkout-leaving').modal('show');
            }
        });
        $('#modal-checkout-leaving-close').bind("click", function(event){
            $('#modal-checkout-leaving').modal('hide');
            pde(event);
        });
    }

    // modal newsletter form event
    $('#modal-newsletter-form').submit(function(event){
        var form = $(this);
        if(form.valid()) {
            $('#modal-newsletter').modal('hide');
        }
    });

    // product overview filter and sort options
    $('.webshop-product-list .form-control').on('change', function(){
        if($(this).hasClass('filter_dropdown')) {
            var nameExploded = $(this).val().split('_');
            var targetDirection = nameExploded.pop();
            var targetName = nameExploded.join('_');
            var baseUrl = window.location.origin + window.location.pathname;
            var queryVars = {};
            queryVars.sort_direction = targetDirection;
            queryVars.sort_name = targetName;
            delete queryVars[''];
            window.location = baseUrl + '?' + $.param(queryVars);
        } else {
            var newUrl = $(this).val();
            if(newUrl) window.location = newUrl;
        }
        return false;
    });

    // clear recently viewed products
    $('.clear-recently-viewd').bind("click", function(){
        $.ajax({
            url:"/bjax/webshop/clearrecentlyviewed/",
            success: function() {
                $('.webshop-recently-viewed').fadeOut(200);
            }
        });
    });

    // activate jquery validation
    $('.form-validation').each(function(){
        $(this).validate({
            rules: {
                Naam: {
                    minlength: 3,
                    maxlength: 55,
                    required: true
                },
                Emailadres: {
                    minlength: 3,
                    maxlength: 55,
                    email: true,
                    required: true
                },
                username:{
                    minlength: 3,
                    maxlength: 55,
                    email: true,
                    required: true
                },
                password: {
                    required: true
                },
                password1: {
                    minlength: 8,
                    required: true
                },
                password2: {
                    minlength: 8,
                    required: true,
                    equalTo: "#acc_create_pass1"
                },
                Telefoonnummer: {
                    minlength: 3,
                    maxlength: 15,
                    number: true,
                    required: true
                },
                Bericht: {
                    minlength: 15,
                    required: true
                },
                acc_company: {
                    required: true
                },
                acc_vnaam: {
                    required: true
                },
                acc_anaam: {
                    required: true
                },
                acc_email: {
                    minlength: 3,
                    maxlength: 55,
                    email: true,
                    required: true
                },
                acc_telnr: {
                    minlength: 3,
                    maxlength: 15,
                    number: true,
                    required: false
                },
                acc_invoice_street: {
                    required: true
                },
                acc_invoice_streetnr: {
                    required: true
                },
                acc_invoice_zipcode: {
                    required: true
                },
                acc_invoice_city: {
                    required: true
                },
                acc_hww: {
                    required: true
                },
                acc_nww1: {
                    minlength: 8,
                    required: true
                },
                acc_nww2: {
                    minlength: 8,
                    required: true,
                    equalTo: "#acc_nww1"
                },
            },
            highlight: function(element) {
                $(element).closest('.form-group').addClass('error');
            },
            unhighlight: function(element) {
                $(element).closest('.form-group').removeClass('error');
            },
            errorElement: 'div',
            errorClass: 'alert alert-danger',
            errorPlacement: function(error, element) {
                if (element.parent('.input-group').length) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            }
        });
    });

    // checkout redirect form
    if($("form#psp-redirect").size() > 0){
        setTimeout(function(){
            $("form#psp-redirect").submit();
        }, 2000);
    }
    // shoppingcart
    else if($('.checkout-cart-form').size() > 0) {
        var cart_form = $('.checkout-cart-form');
        var cart_button = $('.checkout-cart-submit');
        var items = $('.checkout-cart-items .item');
        var command = cart_form.find('input[name="command"]');
        var checkout_type = cart_form.find('input[name="checkout_type"]');
        items.each(function(){
            var $item = $(this);
            var count = $(this).find('.form-control');
            var btn_delete = $(this).find('.checkout-cart-item-delete');
            var btn_reload = $(this).find('.checkout-cart-item-refresh');
            count.focusout(function () {
                if ($(this).val() === '') {
                    $(this).val('0');
                }
                updateCartQuantity($item);
            }).keyup(function () {
                var val = parseInt($(this).val().replace(/\D/g, ''));
                if (val <= 0 || isNaN(val)) {
                    val = "";
                }
                $(this).val(val);
            });
            btn_delete.on('click', function () {
                dataLayer.push({
                    event: 'removeFromCart',
                    ecommerce: {
                        currencyCode: 'EUR',
                        remove: {
                            products: [{
                                id: $item.data('id'),
                                name: $item.data('name'),
                                price: $item.data('price'),
                                brand: $item.data('brand'),
                                category: $item.data('category'),
                                variant: $item.data('variant'),
                                position: $item.data('position'),
                                quantity: $item.data('count')
                            }]
                        }
                    }
                });
                count.val(0);
                cart_form.submit();
            });
            btn_reload.on('click.form_reload', function(){
                updateCartQuantity($item);
            });
        });
        $('.js-checkout-shipopt').on('change',function () {
            cart_form.submit();
        });
        $('.checkout-discount-link').bind('click', function (event) {
            $(this).slideUp(150);
            $('.checkout-discount-options').slideDown(150);
            pde(event);
        });
        if($('.checkout-discount-options .form-control').val() !== '') {
            $('.checkout-discount-link').hide();
            $('.checkout-discount-options').slideDown(150);
        }
        cart_button.bind('click', function (event) {
            var cart_valid = true;
            items.each(function(){
                var maxamount = parseInt($(this).find('.maxamount').val());
                var itemcount = parseInt($(this).find('.form-control').val());
                if(cart_valid === true && itemcount > maxamount){
                    cart_valid = false;
                    $(this).find('.checkout-cart-item-count').focus().popover({
                        placement: 'top',
                        trigger: 'manual',
                        html: true,
                        content: '<label><span class="fa fa-warning"></span></label> U kunt maximaal '+ maxamount +' bestellen',
                        template: '<div class="popover fade top in"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content popover-update"></div></div>',
                    }).popover('show');
                    clearTimeout(popovertimer);
                    popovertimer = setTimeout(function(){
                        $('.checkout-cart-item-count').popover('destroy');
                    },3000);
                }
            });
            if(cart_valid === true){
                if(checkout_type.val() === 'intermediary') {
                    command.attr('value', 'intermediary');
                } else {
                    command.attr('value', 'create_order');
                }
                cart_form.submit();
            }
            pde(event);
        });
        command.val('updatecart');
        window.onpageshow = function(event) {
            if (event.persisted) {
                command.val('updatecart');
            }
        };
        var updateCartQuantity = function($item) {
            var $itemCount = $item.find('.checkout-cart-item-count');
            var oldQuantity = $item.data('count');
            var newQuantity = parseInt($itemCount.val());
            var maxQuantity = parseInt($itemCount.attr('max'));
            var minQuantity = parseInt($itemCount.attr('min'));
            var _popover = {
                placement: 'bottom',
                trigger: 'manual',
                content: $itemCount.data('max-msg')
            };
            var _popoverMin = {
                placement: 'bottom',
                trigger: 'manual',
                content: $itemCount.data('min-msg')
            };

            $itemCount.popover('destroy');

            if(newQuantity > maxQuantity) {
                $itemCount.val(maxQuantity);
                $itemCount.popover(_popover).popover('show');

                setTimeout(function() {
                    $itemCount.popover('destroy');
                }, 5000);

                return false;
            }

            if(newQuantity < minQuantity) {
                $itemCount.val(minQuantity);
                $itemCount.popover(_popoverMin).popover('show');

                setTimeout(function() {
                    $itemCount.popover('destroy');
                }, 5000);

                return false;
            }

            var product = {
                id: $item.data('id'),
                name: $item.data('name'),
                price: $item.data('price'),
                brand: $item.data('brand'),
                category: $item.data('category'),
                variant: $item.data('variant'),
                position: $item.data('position')
            };

            if(oldQuantity > newQuantity) {
                product.quantity = (oldQuantity - newQuantity);
                dataLayer.push({
                    event: 'removeFromCart',
                    ecommerce: {
                        currencyCode: 'EUR',
                        remove: {
                            products: [product]
                        }
                    }
                });
            } else if (newQuantity > oldQuantity) {
                product.quantity = (newQuantity - oldQuantity);
                dataLayer.push({
                    event: 'addToCart',
                    ecommerce: {
                        currencyCode: 'EUR',
                        add: {
                            products: [product]
                        }
                    }
                });
            }

            cart_form.submit();
        };
    }
    // checkout page
    else if($('.checkout-order-form').size() > 0) {
        var order_form = $('.checkout-order-form');
        var order_button = $('.checkout-order-submit');
        $(".checkout-order-form .form-control").bind('change',function(event){
            if($(event.target).closest('.form-group').find('.alert-system').length) {
                $(event.target).closest('.form-group').removeClass('error').find('.alert-system').remove();
            }
        });
        var error_msg = "";
        var error_messager = function() {
            return error_msg;
        };
        jQuery.validator.addMethod("btwnummer", function(value, element) {
            var invoice_country = $('.js-country-address');
            if(invoice_country.val() === 'nl') {
                if(value === '' || (value.length === 14 && value.match(/^[A-Z]{2}[0-9]{9}[A-Z]{1}[0-9]{2}/g))) {
                    error_msg = "";
                    return true;
                } else {
                    error_msg = "Ongeldig BTW nummer (vb. NL001234567B01)";
                    return false;
                }
            }
            else if(invoice_country.val() === 'be') {
                if(value === '' || (value.length === 12 && value.match(/^[A-Z]{2}[0-9]{10}/g))) {
                    error_msg = "";
                    return true;
                } else {
                    error_msg = "Ongeldig BTW nummer (vb. BE0123456789)";
                    return false;
                }
            } else {
                error_msg = "";
                return true;
            }
        }, error_messager);
        jQuery.validator.addMethod("futuredate", function(value, element) {
            var today = new Date().getTime();
            var date = value.split('-');
            var timevalue = new Date(date[2], date[1]-1, date[0]);
            timevalue.setDate(timevalue.getDate() +1);
            if(timevalue <= today) {
                return false;
            } else {
                return true;
            }
        }, "Een toekomstige datum is verplicht.");

        order_button.button('reset');

        window.onpageshow = function(event) {
            if (event.persisted) {
                order_button.button('reset');
            }
        };
        $(".checkout-order-form textarea[name='data[buyer][note]']").keyup(function(){
            $(this).closest('.form-group').find('.alert').remove();
            if($(this).val().toLowerCase().match(/(bezorgen|buren)/)){
                $(this).closest('.form-group').append('<div class="alert alert-danger"><em>De pakketbezorger leest deze opmerking niet, wij gaan niet over het bezorgbeleid van de pakketbezorger.</em></div>');
            }
        });

        jQuery.validator.addMethod('shipping_pickup_location', function(value, element) {
            return $('.js-pickup__location-name').val() != '';
        }, 'Selecteer een afhaalpunt bij u in de buurt.');

        jQuery.validator.addMethod('shipping_timeframe', function(value, element) {
            return $('.js-timeframe__option').val() != '';
        }, 'Selecteer een geschikt aflevermoment.');

        jQuery.validator.addMethod('zipcodeNL', function(value, element) {
            if($('.checkout-order-form').hasClass('validate-zipcode')) {
                return this.optional( element ) || /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/.test( value );
            } else {
                return true;
            }
        }, 'Vul een geldige postcode in, bijv: 1234AB' );

        jQuery.validator.addClassRules('js-pickup__zipcode', {
            required: true,
            zipcodeNL: true
        });

        order_form.validate({
            onkeyup: function(element) {
                $(element).valid();
            },
            rules:{
                "data[buyer][vat]": {
                    btwnummer: true
                },
                "data[shipping][date]": {
                    futuredate: true,
                    dateNL: true
                },
                "data[invoice][zipcode]": {
                    required: true,
                    zipcodeNL: true
                },
                "data[shipping][zipcode]": {
                    required: true,
                    zipcodeNL: true
                },
                "data[buyer][birthdate]": {
                    dateNL: true
                },
                "data[pickup][company]": {
                    shipping_pickup_location: true
                },
                "data[timeframe][option]": {
                    shipping_timeframe: true
                },
                "shippingMethodOption": {
                    required: true
                }
            },
            messages: {
                "shippingMethodOption": "Kies een bezorgoptie"
            },
            highlight: function(element) {
                $(element).closest('.form-group').addClass('error');
            },
            unhighlight: function(element) {
                $(element).closest('.form-group').removeClass('error');
            },
            errorElement: 'div',
            errorClass: 'alert alert-danger',
            errorPlacement: function(error, element) {
                if (element.attr('name') === 'timeframe_option' || element.attr('name') === 'pickup_location') {
                    error.insertBefore(element.parent().parent());
                } else if (element.attr("name") === 'paymentmethod' || element.attr('name') === 'shippingMethodOption') {
                    error.insertBefore(element.parent().parent().parent());
                } else if (element.attr("type") === 'radio') {
                    error.insertBefore(element.parent());
                } else if (element.parent('.input-group').length) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function(order_form) {
                var order_valid = true;
                var _timeout = 0;

                if(order_button.attr('aria-describedby') !== undefined) {
                    order_button.popover('destroy');
                    _timeout = 300;
                }

                setTimeout(function() {
                    $('.js-address-type').each(function(){
                        var $address = $(this),
                            type = $address.data('type'),
                            $typeMessage = $('.js-' + type + '-message'),
                            street = $address.find('.js-street').val(),
                            streetnr = $address.find('.js-streetnr').val(),
                            streetnrAddition = $address.find('.js-streetnr-addition').val();

                        $typeMessage.hide();

                        if(($('#ship-to-invoice').is(':checked') && type === 'invoice') || !$('#ship-to-invoice').is(':checked')) {
                            if(street !== '' && streetnr !== ''){
                                if($address.data('address-check') === '1'){
                                    return false;
                                }
                                if(street.match(streetnr + streetnrAddition + '$') != null || street.match(streetnr + '$') != null) {
                                    $address.data('address-check', '1');

                                    $typeMessage.find('strong').text(street +' '+ streetnr + streetnrAddition);
                                    //$typeMessage.show();

                                    order_valid = false;

                                    order_button.popover('destroy').popover({
                                        placement: 'top',
                                        trigger: 'manual',
                                        html: true,
                                        content: $typeMessage.html(),
                                    }).popover('show');
                                }
                            }
                        }
                    });

                    if($('.checkout-order-paymentmethods input[name="data[payment][method]"]:checked').attr('data-method') === 'afterpay'){
                        if($('#afterpay_accept:checked').length === 0) {
                            order_valid = false;
                            order_button.popover('destroy').popover({
                                placement: 'top',
                                trigger: 'manual',
                                content: 'Om te kunnen bestellen moet u de Afterpay betalingsvoorwaarden accepteren.',
                                template: '<div class="popover fade top in"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                            }).popover('show');
                            clearTimeout(popovertimer);
                            popovertimer = setTimeout(function(){
                                order_button.popover('destroy');
                            },3000);
                        }
                    }
                    if(order_valid === true && $('#order_accept:checked').length === 0) {
                        order_valid = false;
                        order_button.popover('destroy').popover({
                            placement: 'top',
                            trigger: 'manual',
                            content: 'Om te kunnen bestellen moet u onze algemene voorwaarden accepteren.',
                            template: '<div class="popover fade top in"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                        }).popover('show');
                        clearTimeout(popovertimer);
                        popovertimer = setTimeout(function(){
                            order_button.popover('destroy');
                        },3000);
                    }
                    if(order_valid === true) {
                        var deliveryDay = $(".checkout-order-form-left").find('input[name="call_in_advance"]:checked').val();
                        var buyerNote = $(".checkout-order-form-left").find('textarea[name="data[buyer][note]"]').val();
                        $('#order_note').val("Bel optie: "+deliveryDay+".  "+"Opmerking: "+buyerNote);
                        order_button.button('loading');
                        order_form.submit();
                    }
                }, _timeout);
            }
        });
        if($('.checkout-order-paymentmethods input[name="data[payment][method]"]:checked').length !== 0) {
            var payment_methode = $('.checkout-order-paymentmethods input[name="data[payment][method]"]:checked').attr('data-method');
            if(payment_methode === 'afterpay' || payment_methode === 'billink') {
                $('.checkout-order-form label[for="buyer_vat"]').text("BTW nummer *");
                $('.checkout-order-form label[for="buyer_coc"]').text("KVK nummer *");
                $('#buyer_vat, #buyer_coc').attr('required', true);
            }
        }
        $('#ship-to-invoice').on('click', function (event) {
            if ($(this).prop('checked')) {
                $("#shipping-address-area, .checkout-order-billing-address").hide();
                $("#shipping-address-area :input").attr("disabled", true);
                $("#ship-to-shipping").attr("disabled", true);
                $('.account-delivery-address').fadeOut();
            } else {
                $("#shipping-address-area, .checkout-order-billing-address").show();
                $("#shipping-address-area :input").attr("disabled", false);
                $("#ship-to-shipping").attr("disabled", false);
                $('.account-delivery-address').fadeIn();
            }
        });
        if ($("#shipping-address-area:hidden").length === 1) {
            $('#shipping-address-area:hidden :input').attr('disabled', true);
        }
        if ($("#business-fields:hidden").length === 1) {
            $('#business-fields:hidden :input').attr('disabled', true);
        }
        $(".checkout-order-form input[name='data[buyer][type]']").on("change", function(){
            var value = $(this).val();
            if(value === 'business'){
                $("#business-fields").show();
                $("#business-fields :input").attr('disabled', false);
                $('.js-buyer-type').toggleClass('hidden');
                $('#buyer_company').attr('required', true);
            }else{
                $("#business-fields").hide();
                $("#business-fields :input").attr('disabled', true);
                $('.js-buyer-type').toggleClass('hidden');
                $('#buyer_company').attr('required', false);
            }
        });
        $('.checkout-order-paymentmethods input[name="data[payment][method]"]').bind('change', function(){
            $('.paymentmethods-form-groups').hide();
            $('.paymentmethods-form-groups :input').attr("disabled", true);
            $(this).parent().parent().find('.paymentmethods-form-groups').show();
            $(this).parent().parent().find('.paymentmethods-form-groups :input').attr("disabled", false);
            if($(this).attr('data-method') === 'afterpay' || $(this).attr('data-method') === 'billink') {
                $('.checkout-same-address').hide();
                $('#ship-to-invoice').prop('checked',true);
                $("#shipping-address-area, .checkout-order-billing-address").hide();
                $("#shipping-address-area :input").attr("disabled", true);
                $("#ship-to-shipping").attr("disabled", true);
                $('.checkout-order-form label[for="buyer_vat"] .js-payment-toggle').removeClass('hidden');
                $('.checkout-order-form label[for="buyer_coc"] .js-payment-toggle').removeClass('hidden');
                $('#buyer_vat, #buyer_coc').attr('required', true);
            } else {
                $('.checkout-same-address').show();
                $('.checkout-order-form label[for="buyer_vat"] .js-payment-toggle').addClass('hidden');
                $('.checkout-order-form label[for="buyer_coc"] .js-payment-toggle').addClass('hidden');
                $('#buyer_vat, #buyer_coc').attr('required', false);
            }
        });
        $('.checkout-order-paymentmethods input[name="data[payment][method]"]').each(function(){
            if($(this).is(':checked')) {
                $(this).parent().parent().find('.paymentmethods-form-groups').show();
                $(this).parent().parent().find('.paymentmethods-form-groups :input').attr("disabled", false);
            } else {
                $(this).parent().parent().find('.paymentmethods-form-groups').hide();
                $(this).parent().parent().find('.paymentmethods-form-groups :input').attr("disabled", true);
            }
        });

        $('.js-zipcode, .js-streetnr').change(function (event) {
            var parent = $(this).parents('.js-address-type');
            var postcode = parent.find('.js-zipcode').val().split(' ').join('');

            if (isValidZipcode(postcode)) {
                $.ajax({
                    dataType: "json",
                    url: "/bjax/webshop/postcodefill/",
                    data: {postcode: postcode, huisnr: parent.find('.js-streetnr').val()},
                    success: function (json) {
                        if (json) {
                            parent.find('.js-street').val(json.street);
                            parent.find('.js-city').val(json.city);
                        }
                    }
                });
            }
        });
    }

    // Checkout page automatic postcode fill
    function isValidZipcode(zipcode) {
        return zipcode.match(/^[1-9][0-9]{3}[\ ]*[A-z]{2}$/i);
    }

    // Main filter toggle (mobile/desktop)
    $('.js-filter-toggle').on('click', function(){
        $(this).toggleClass('closed');
        $(this).next('.js-filter-options').slideToggle();
    });

    // Toggle for sub filters
    $('.js-sub-filter-toggle').on('click', function(){
        $(this).toggleClass('closed');
        $(this).next('.js-filters').slideToggle();
    });

    // Toggle maximum of 3 filters (attribute filter)
    $('.js-showmore').on('click', function() {
        $(this).parents('.js-filters').find('.js-hidden').slideToggle();
        $(this).text() === 'Toon meer' ? $(this).text('Toon minder') : $(this).text('Toon meer');
    });

    var $promobar = $('.promobar');
    if ($promobar.length) {
        $(window).on('scroll.promobar', function() {
            if($(window).scrollTop() > $promobar.innerHeight()) {
                $('.promobar').removeClass('visible');
            } else {
                $('.promobar').addClass('visible');
            }
        });
    }

    //moment();

    // $('#shipping_date').datetimepicker({
    //     locale: 'nl',
    //     format: 'DD-MM-YYYY'
    // });

    $('.checkout-cart-item-deliveryaddress').click(function(event){
        $('#loading').show();

        var frameSrc = $(this).attr('href');

        $('#iframe_extra_address').attr("src",frameSrc);

        $('#AddressModal').modal({show:true});

        pde(event);
    });

    $('#iframe_extra_address').load(function() {
        $('#loading').hide();
    });


    $('.js-feature-radio').each(function() {

        var $feature = $(this),
            $title = $feature.find('.js-feature-radio-title'),
            $optionsContainer = $feature.find('.js-feature-radio-options'),
            $options = $feature.find('.js-feature-radio-option'),
            $checkedImage = $title.find('.js-feature-radio-img'),
            $checkedLabel = $title.find('.js-feature-radio-label');

        $optionsContainer.hide();

        $title.on('click', function() {
            if($feature.hasClass('feature-radio--open')) {
                $optionsContainer.slideUp();
                $feature.removeClass('feature-radio--open');
            } else {
                $feature.addClass('feature-radio--open');
                $optionsContainer.slideDown();
            }
        });

        $options.on('change', function() {
            var $option = $(this);

            $options.not($option).parent().removeClass('feature-radio__option--checked');
            $option.parent().addClass('feature-radio__option--checked');
            $feature.addClass('feature-radio--checked');
            $feature.attr('labelprice', $option.attr('labelprice'));
            $feature.attr('labelpriceex', $option.attr('labelpriceex'));
            $checkedImage.attr('src', $option.data('img'));
            $checkedLabel.text($option.data('label'));
            $title.trigger('click');
        })
    });

    function update_price(incl, excl){

        var price = parseInt($('.js-price').val())  + parseInt(incl);
        var priceEx = parseInt($('.js-price-excl').val()) + parseInt(excl);

        $('.actualPrice').text(priceEx).priceFormat({
            prefix: '€ ',
            centsSeparator: ',',
            thousandsSeparator: ''
        });
        $('.oldPrice').text(price).priceFormat({
            prefix: '€ ',
            centsSeparator: ',',
            thousandsSeparator: ''
        });
    }

    $('.js-feature-options').each(function () {
        var select = $(this);
        var selectImage = $('.js-feature-radio-option');

        select.add(selectImage).on('change', function () {
            var totalin = 0;
            var totalex = 0;

            $('.js-feature-options').each(function () {
                if($(this).is("input")) {
                    if($(this).is(":checked")) {
                        var price = $(this).attr('labelprice');
                        var priceEx = $(this).attr('labelpriceex');
                    } else {
                        var price = 0;
                        var priceEx = 0;
                    }
                } else {
                    var price = $(this).find("option:selected").attr('labelprice');
                    var priceEx = $(this).find("option:selected").attr('labelpriceex');
                }

                totalin += parseInt(price);
                totalex += parseInt(priceEx);
            });

            $('.js-feature-radio-selected').each(function () {

                var price = $(this).attr('labelprice');
                var priceEx = $(this).attr('labelpriceex');

                if(typeof price == 'undefined'){
                    price = 0;
                }
                if(typeof priceEx == 'undefined'){
                    priceEx = 0;
                }

                totalin += parseInt(price);
                totalex += parseInt(priceEx);
            });
            update_price(totalin, totalex);
        });
    });

})();


